module.exports = __webpack_public_path__ + "static/media/bg8.8cfdd67a.jpg";